export function formatAddress(obj) {
  const { street, district, city, state, cep, additional } = obj || {};

  if (!street || !district || !city || !state || !cep) {
    return "Endereço incompleto / não preenchido";
  }

  return `${street} - ${district}, ${city} - ${state}, ${cep}${
    additional ? ` (${additional})` : ""
  }`;
}
